import firebase from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getFirestore, collection, addDoc } from "firebase/firestore";
import "firebase/firestore";
import "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCVGhN56NVkWrjQW-otvzkYfyo8pozjr7s",
  authDomain: "fatmen-site-4f654.firebaseapp.com",
  projectId: "fatmen-site-4f654",
  storageBucket: "fatmen-site-4f654.appspot.com",
  messagingSenderId: "268408341881",
  appId: "1:268408341881:web:d44433a1dfade8a6ce9ba8",
  measurementId: "G-QHNXXNVF7F",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// const analytics = firebase.getAnalytics();
export const firestore = firebase.firestore();
export const storage = firebase.storage();

export const fetchVideosDataInDb = async () => {
  try {
    let doc = await firestore.collection("pages").doc("videos").get();
    if (!doc || !doc.data()) throw "Unable to get request";

    return doc.data();
  } catch (err) {
    console.log(err);
    if (err.message) throw err.message;
    else throw "Invalid request";
  }
};

export const fetchClientsDataInDb = async () => {
  try {
    let doc = await firestore.collection("pages").doc("clients").get();
    if (!doc || !doc.data()) throw "Unable to get request";

    return doc.data();
  } catch (err) {
    console.log(err);
    if (err.message) throw err.message;
    else throw "Invalid request";
  }
};
